import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { SET_SCREEN_TYPE } from './store';

export const useScreenDetector = () => {
  const dispatch = useDispatch();

  // useMediaQuery automatically handles resize events
  const isDesktop = useMediaQuery({ minWidth: 861 });

  useEffect(() => {
    // Dispatch whenever screen size crosses the threshold
    dispatch({ type: SET_SCREEN_TYPE, payload: isDesktop });
  }, [isDesktop, dispatch]);
};